import { offering_availability_statuses } from "features/Listings/Listings.constants";

export const offering_status_tooltip_texts = {
  [offering_availability_statuses.live]:
    "The offering is live. This Landing Page will lead to a payment page.",
  [offering_availability_statuses.sold_out]:
    "The offering is in waitlist. This Landing Page will lead to a page with Waitlist form.",
  [offering_availability_statuses.expired]:
    "The offering has expired. This Landing Page will lead to a Get in Touch form page.",
};

export const STATUS_BADGE_CONFIGS = {
  active: {
    bg: "tw-bg-[#E6F7F0]",
    text: "tw-text-[#00AC72]",
    dot: "tw-bg-[#00AC72]",
    label: "Live",
  },
  paused: {
    bg: "tw-bg-[#FFF7E6]",
    text: "tw-text-[#FFAA00]",
    dot: "tw-bg-[#FFAA00]",
    label: "Paused",
  },
  inactive: {
    bg: "tw-bg-[#FEECEC]",
    text: "tw-text-[#DA2A2A]",
    dot: "tw-bg-[#DA2A2A]",
    label: "Inactive",
  },
  draft: {
    bg: "tw-bg-amber-50",
    text: "tw-text-amber-600",
    dot: "tw-bg-amber-500",
  },
};
